import React, { Component } from "react";
import AppContext from "../../../contexts/AppContext";

class List extends Component {
    state = {
        item: {}
    };

    render() {
        return (
            <div class="card">
                <div class="card-body">
                    <div class="row align-items-center">
                        <div class="col-auto">
                            <a
                                 href={`/pw/${this.props.item.user.url}`}
                                class="avatar avatar-lg"
                                target="_blank"
                            >
                                <img
                                    src={this.props.item.user.image}
                                    alt=""
                                    class="avatar-img rounded-circle"
                                ></img>
                            </a>
                        </div>
                        <div class="col ml-n2">
                            <h4 class="card-title mb-1">
                                <a  href={`/pw/${this.props.item.user.url}`} target="_blank">
                                    {" "}
                                    {this.props.item.user.first_name}{" "}
                                    {this.props.item.user.last_name}
                                </a>
                            </h4>
                            <p class="card-text small text-muted mb-1">
                                last visit {this.props.item.created_at}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
List.contextType = AppContext;
export default List;



// WEBPACK FOOTER //
// ./src/components/writer/visitors/List.js